module.exports = __webpack_public_path__ + "img/default-image.8ab0e1f3.jpg";